const premiumplanViewPin = (() => {
  if (document.querySelector("body#pagePremiumplan") !== null) {



    let sW = window.innerWidth;


    gsap.to('#jsSecView .js-pin-wrap .js-pin-area', {
      scrollTrigger: {
        trigger: '#jsSecView .js-pin-wrap .js-pin-area',
        start: '50% 50%',
        endTrigger: '#jsSecView .js-pin-wrap',
        end: '100% 100%',
        pin: true,
        pinSpacing: false,
        // markers: true
      }
    });


    let secView = document.querySelector('#jsSecView');
    let pinWrap = secView.querySelector('.js-pin-wrap');
    let pinAreas = pinWrap.querySelector('.js-pin-area');
    let trgAreas = pinWrap.querySelectorAll('.js-trg-area');

    trgAreas.forEach((element, index) => {

      let tl = gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: element,
          start: '50% 50%',
          endTrigger: 'body',
          end: '100% 0%',
          onEnter: () => pinAreas.classList.add(`is-act-${index}`),
          // onLeave: () => console.log("onLeave"),
          // onEnterBack: () => console.log("onEnterBack"),
          onLeaveBack: () => pinAreas.classList.remove(`is-act-${index}`),
          // markers: true,
        },
      })

      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          tl.scrollTrigger.refresh()
        });
      });
      observer.observe(target);

    });





  }
})()
export default premiumplanViewPin;